import React, { Component } from "react";
import Pagination from "../Pagination/Pagination";

import "./Comments.css";
import Filter from "../Filter/Filter";

class Comments extends Component {
    constructor(props) {
        super(props);
        this.request_data = this.request_data.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.on_page_change = this.on_page_change.bind(this);
        this.delete_comment = this.delete_comment.bind(this);
        this.confirm_comment = this.confirm_comment.bind(this);
    }

    componentDidMount() {
        this.request_data();
    }

    componentDidUpdate(prevProps, prevState) {
        let { page, count, filters } = this.state;
        if (
            prevState.page !== page ||
            prevState.count !== count ||
            prevState.filters !== filters
        ) {
            this.request_data();
        }
    }

    on_page_change(page) {
        this.setState({ page });
    }

    request_data() {
        let { toast, connection } = this.props;
        let { filters, page, count } = this.state;
        filters = filters || {};
        !filters.sort && (filters.sort = "time");
        connection
            .get_filtered_data("comments", filters, null, count, null, page)
            .then((res) => {
                let { comments, total, page } = res.data;

                this.setState({ comments, total, page });
            })
            .catch((err) => {
                toast("خطا در دریافت نظرات", " خطای : " + err, " danger");
            });
    }

    delete_comment(id) {
        this.props.connection
            .delete_comment(id)
            .then((res) => {
                this.request_data();
            })
            .catch((err) => {});
    }

    confirm_comment(id) {
        this.props.connection
            .confirm_comment(id)
            .then((res) => {
                this.request_data();
            })
            .catch((err) => {});
    }

    onFilterChange(filters) {
        let statuses = [];
        filters.sent && statuses.push('"sent"') && delete filters.sent;
        filters.notPayed &&
            statuses.push('"notPayed"') &&
            delete filters.notPayed;
        filters.pending && statuses.push('"pending"') && delete filters.pending;
        statuses.length > 0 && (filters.status = `[${statuses.join(",")}]`);

        filters.search == "" && delete filters.search;

        this.setState({ filters });
    }
    state = {
        comments: null,
        count: 10,
        page: 0,
        total: null,
        filters: null,
    };

    render() {
        let { comments, count, total, page } = this.state;
        return (
            <div className="CommentsContainer">
                <Filter
                    filters={[{ label: "تایید نشده", value: "notConfirmed" }]}
                    onFilterChange={this.onFilterChange}
                />
                <div className="CommentsWraper">
                    {comments &&
                        comments.length > 0 &&
                        comments.map((c) => {
                            return (
                                <div
                                    className={
                                        "commentRow " + (!c.isRead && "notRead")
                                    }
                                    key={c.comment_id}
                                >
                                    <div className="item">
                                        <a href={"/items/" + c.item}>
                                            {c.item}
                                        </a>
                                    </div>
                                    <div className="costumer">
                                        <div className="name text secondary">
                                            {c.poster.name}
                                        </div>
                                        <div className="mobile text info">
                                            {c.poster.mobile
                                                ? c.poster.mobile
                                                : ""}
                                        </div>
                                    </div>

                                    <div className="message">{c.message}</div>

                                    <div className="actions">
                                        {c.confirmed != true && (
                                            <button
                                                className="btn confirm"
                                                onClick={(ev) =>
                                                    this.confirm_comment(c.id)
                                                }
                                            >
                                                <i className="fa-solid fa-check"></i>
                                            </button>
                                        )}
                                        <button
                                            className="delete btn danger"
                                            onClick={(ev) =>
                                                this.delete_comment(c.id)
                                            }
                                        >
                                            <i class="ri-delete-bin-6-line"></i>
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                </div>
                {total && page !== null && count && (
                    <Pagination
                        count={count}
                        page={page}
                        total={total}
                        on_page_change={(p) => this.on_page_change(p)}
                    />
                )}
            </div>
        );
    }
}

export default Comments;
